import { AxiosResponse } from "axios";

export const getAPIData = <T = any>(promise: Promise<AxiosResponse<T>>) => {
  return promise.then((res) => {
    return res.data;
  });
};
